import { Injectable } from "@angular/core";
import { MCAuthoritiesEventsHealth } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsHealth extends MCAuthoritiesEventsHealth {


}
